import { GENERAL_URL_API } from "../../../urls";

export const asignarBannerInstitutos = async (idBanner, institutos) => {
  try {
    const formData = new FormData();
    formData.append("idBanners", idBanner);
    formData.append("institutos", JSON.stringify(institutos));
    
    const response = await fetch(`${GENERAL_URL_API}/arte/asignarInstitutosBanner.php`, {
      method: "POST",
      credentials: 'include',
      body: formData,
    });

    const data = await response.json();
    
    if (data.status === 1) {
      return {
        status: true,
        info: "Asignaciones guardadas exitosamente",
        data: data.data
      };
    } else {
      return {
        status: false,
        info: data.info || "Error al guardar las asignaciones"
      };
    }
  } catch (error) {
    console.error("Error en asignarBannerInstitutos:", error);
    return {
      status: false,
      info: "Error de conexión al guardar las asignaciones"
    };
  }
};

export const verAsignacionesBanner = async (idBanner) => {
  try {
    const formData = new FormData();
    formData.append("idBanners", idBanner);
    
    const response = await fetch(`${GENERAL_URL_API}/arte/verAsignacionesBanner.php`, {
      method: "POST",
      credentials: 'include',
      body: formData,
    });

    const data = await response.json();
    
    if (data.status === 1) {
      return {
        status: true,
        data: data.data || [],
        info: "Asignaciones obtenidas exitosamente"
      };
    } else {
      return {
        status: false,
        data: [],
        info: data.info || "Error al obtener asignaciones"
      };
    }
  } catch (error) {
    console.error("Error en verAsignacionesBanner:", error);
    return {
      status: false,
      data: [],
      info: "Error de conexión al obtener asignaciones"
    };
  }
}; 